import { isValidElement, ReactElement, ReactNode } from 'react'

import { HorizontalMenuItem } from '../components/horizontalMenuItem/HorizontalMenuItem'
import { IHorizontalMenuItemProps } from '../components/horizontalMenuItem/models'

export const isHorizontalMenuItem = (
  child: ReactNode
): child is ReactElement<IHorizontalMenuItemProps> => {
  return isValidElement<IHorizontalMenuItemProps>(child) && child.type === HorizontalMenuItem
}
